module.exports = __webpack_public_path__ + "media/images/community_stories/your_community_12-d1f703742197a921787e1c036a8d39b9.jpg";